import React, {FC, useEffect, useState} from 'react'
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField
} from "@material-ui/core";
import {Strings} from "../../../Resources/Strings";
import {margin, padding} from "../../../styles/styleConstants";
import {Autocomplete} from "@material-ui/lab";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../redux/store";
import {isEmpty} from "../../../utils/utils";
import {IActivityRecord} from "../../../api/IActivityRecord";
import {addActivityRecordCompromiseThunk, compromise} from "../../../redux/compromise";
import {IUserModel} from "../../../api/IUserModel";
import {LoadingButton} from "../../DataTemplates/LoadingButton/LoadingButton";

export interface AddActivityRecordCompromiseDialogComponentProps {
    activityRecord?: IActivityRecord
    users: IUserModel[]
}

export const AddActivityRecordCompromiseDialogComponent: FC<AddActivityRecordCompromiseDialogComponentProps> = (props) => {
    const dispatch = useDispatch();
    const {activityRecords} = useSelector((state: RootState) => state.activityRecord);
    const {isAddingActivityRecordCompromise} = useSelector((state: RootState) => state.compromise);
    const users = props.users;
    const activityRecord = props.activityRecord;

    const [title, setTitle] = useState<string>('');
    const [selectedActivityRecord, setSelectedActivityRecord] = useState<IActivityRecord>();
    const [selectedUser, setSelectedUser] = useState<IUserModel>();

    const [isLoading, setIsLoading] = useState<boolean>()
    const [isYesAvailable, setIsYesAvailable] = useState<boolean>(false)

    useEffect(() => {
        setSelectedUser(null)
        if (activityRecord !== null && activityRecord !== undefined)
            setSelectedActivityRecord(activityRecord)
        else setSelectedActivityRecord(null)
    }, [isAddingActivityRecordCompromise])

    useEffect(() => {
        if (isEmpty(title) || selectedActivityRecord === undefined ||
            selectedActivityRecord === null || selectedUser === null || selectedUser === undefined)
            setIsYesAvailable(false)
        else setIsYesAvailable(true)
    }, [title, selectedActivityRecord, selectedUser]);

    const handleNo = () => {
        dispatch(compromise.actions.closeAddActivityRecordCompromise());
    }

    const handleYes = async () => {
        setIsLoading(true)
        await dispatch(addActivityRecordCompromiseThunk(selectedActivityRecord.id, selectedUser.id, title))
        setIsLoading(false)

        // Add compromise
        await dispatch(compromise.actions.openEditCompromise())
    }

    const titleChangedCallback = (event: any | HTMLInputElement) => {
        setTitle(event.target.value)
    }

    return <>
        <Dialog open={isAddingActivityRecordCompromise} onClose={handleNo} fullWidth>
            <DialogTitle>{Strings.NewCompromise}</DialogTitle>
            <DialogContent>
                <Grid container direction='column'>
                    <Grid item>
                        <Box m={margin} p={padding}>
                            <TextField label={Strings.Title} onChange={titleChangedCallback} fullWidth/>
                        </Box>
                    </Grid>
                    {!activityRecord &&
                    <Grid item>
                        <Box m={margin} p={padding}>
                            <Autocomplete fullWidth
                                          value={selectedActivityRecord}
                                          onChange={(event: any, newValue: IActivityRecord | null) => {
                                              setSelectedActivityRecord(newValue)
                                          }}
                                          id="activity-record-autocomplete"
                                          options={activityRecords}
                                          getOptionLabel={(option) => `${option.title} ${option.date}`}
                                          renderInput={(params) =>
                                              <TextField {...params} label={Strings.ActivityRecord}
                                                         variant="outlined"/>}/>
                        </Box>
                    </Grid>}
                    <Grid item>
                        <Box m={margin} p={padding}>
                            <Autocomplete fullWidth
                                          value={selectedUser}
                                          onChange={(event: any, newValue: IUserModel | null) => {
                                              setSelectedUser(newValue)
                                          }}
                                          id="user-autocomplete"
                                          options={users}
                                          getOptionLabel={(option) => `${option.email}`}
                                          renderInput={(params) =>
                                              <TextField {...params} label={Strings.Owner}
                                                         variant="outlined"/>}/>
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <LoadingButton onClick={handleYes} inProgress={isLoading} text={Strings.Yes}
                               variant='contained' disabled={isLoading || !isYesAvailable} color='primary'
                               progressBarColor='secondary'/>
                <Button onClick={handleNo} color="secondary" variant='contained' disabled={isLoading}>
                    {Strings.No}
                </Button>
            </DialogActions>
        </Dialog>
    </>
}